/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UserResponse } from './userResponse';

export interface AuthResponse {
  user: UserResponse;
  message?: string;
  pending_authentication_token?: string | null;
}
